/* ==========================================================================
   Article template — 目次の自動生成
   記事本文（.rte）の h2 を拾って目次を組み立て、スマホでは折りたたみます。
   対象は data-section-type="article-template" 配下のみです。
   ========================================================================== */

(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 767px)';
  var EXCLUDE_SELECTOR = '.cta-card, .summary-box, .article-toc';

  function pad(number) {
    return number < 10 ? '0' + number : String(number);
  }

  function isExcluded(heading) {
    return heading.closest(EXCLUDE_SELECTOR) !== null;
  }

  function collectHeadings(body) {
    var headings = [];

    Array.prototype.forEach.call(body.querySelectorAll('h2'), function (heading) {
      if (isExcluded(heading)) return;
      if (heading.textContent.trim() === '') return;
      headings.push(heading);
    });

    return headings;
  }

  function buildToc(container, headings, sectionId) {
    var listId = 'article-toc-list-' + sectionId;
    var titleText = container.getAttribute('data-toc-title') || '目次';
    var openText = container.getAttribute('data-toc-open') || '開く ＋';
    var closeText = container.getAttribute('data-toc-close') || '閉じる −';
    var openOnMobile = container.getAttribute('data-toc-mobile-open') !== 'false';

    var head = document.createElement('button');
    head.type = 'button';
    head.className = 'article-toc__head';
    head.setAttribute('aria-controls', listId);

    var label = document.createElement('span');
    label.className = 'article-toc__label';
    label.textContent = titleText;
    head.appendChild(label);

    var toggleText = document.createElement('span');
    toggleText.className = 'article-toc__toggle-text';
    head.appendChild(toggleText);

    var list = document.createElement('ol');
    list.className = 'article-toc__list';
    list.id = listId;

    headings.forEach(function (heading, index) {
      var item = document.createElement('li');
      item.className = 'article-toc__item';

      var num = document.createElement('span');
      num.className = 'article-toc__num';
      num.setAttribute('aria-hidden', 'true');
      num.textContent = pad(index + 1);

      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();

      item.appendChild(num);
      item.appendChild(link);
      list.appendChild(item);
    });

    container.innerHTML = '';
    container.appendChild(head);
    container.appendChild(list);
    container.removeAttribute('hidden');

    function setExpanded(expanded) {
      head.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggleText.textContent = expanded ? closeText : openText;
    }

    function syncToViewport() {
      if (window.matchMedia(MOBILE_QUERY).matches) {
        setExpanded(openOnMobile);
      } else {
        setExpanded(true);
      }
    }

    head.addEventListener('click', function () {
      if (!window.matchMedia(MOBILE_QUERY).matches) return;
      setExpanded(head.getAttribute('aria-expanded') !== 'true');
    });

    var mediaQuery = window.matchMedia(MOBILE_QUERY);
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', syncToViewport);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(syncToViewport);
    }

    syncToViewport();
  }

  function numberHeadings(body, headings, sectionId) {
    headings.forEach(function (heading, index) {
      if (!heading.id) {
        heading.id = 'article-heading-' + sectionId + '-' + (index + 1);
      }
      heading.setAttribute('data-cl-num', pad(index + 1));
    });

    body.setAttribute('data-cl-numbered', '');
  }

  function initSection(section) {
    if (!section) return;

    var body = section.querySelector('.rte');
    if (!body) return;

    var sectionId = section.dataset.sectionId || 'article';
    var headings = collectHeadings(body);

    numberHeadings(body, headings, sectionId);

    var container = section.querySelector('[data-article-toc]');
    if (!container) return;

    if (headings.length < 2) {
      container.innerHTML = '';
      container.setAttribute('hidden', '');
      return;
    }

    buildToc(container, headings, sectionId);
  }

  function initAll(root) {
    var scope = root || document;
    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-section-type="article-template"]'),
      initSection
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
